// extracted by mini-css-extract-plugin
export default {"main":"Question_main__ZOfCM","question":"Question_question__CuDKh"};